import { Component, EventEmitter, Input, Output } from '@angular/core';


//定義資料型態
interface placeLocation {
  position:  google.maps.LatLngLiteral;
  name:      string;
  address:   string;
}

@Component({
  selector: 'train-detail',
  standalone: true,
  imports: [],
  templateUrl: './train-detail.component.html',
})
export class TrainDetailComponent {

  @Input() startLocation: placeLocation;
  @Input() endLocation: placeLocation;
  @Input() detailArray: any;


  // [callBack] 回傳父組件事件
  @Output() callBack =  new EventEmitter<{ state: number, num: number }>();
  state:number = 3;
  detail:any;

  getChDate(date:string){
    return date.substring(11, 16);
  }

  getChTime(time: number){
    if(time > 3600){
        //(特殊情況)分鐘無條件進位，排除出現通勤0分鐘的情形。
        return Math.floor(time/3600) + "小時" + Math.ceil((time%3600)/60) + "分鐘";
    }else{
      return Math.ceil(time/60) + "分鐘";
    }
  }

  getChLength(length: number){
    if(length > 1000){
        return (length/1000).toFixed(2) + "公里" ;
    }else{
      return length.toFixed(0) + "公尺";
    }
  }


  getMinute(time: number){
    return Math.ceil(time/60);
  }

  getTypeImg(type: string, transpot:any){
    var imgUrl = "/static/images/svg/ic_";
    switch(type){
      case "waiting":
        imgUrl += "time.svg";
        break;
      case "pedestrian":
      case "pedestrian-station":
        imgUrl += "walk.svg";
        break;
      case "drive":
        imgUrl += "car.svg";
        break;
      case "cycle":
        if(transpot.agency == null){
          imgUrl += "bike.svg";
        }else{
          imgUrl += "ibike.svg";
        }
        break;
      case "transit":
        switch(transpot.mode){
          case "TRA":
            imgUrl += "train.svg";
            break;
          case "HighwayBus":
          case "Bus":
            imgUrl += "bus.svg";
            break;
          case "MRT":
            imgUrl += "mrt.svg";
            break;
          case "HSR":
            imgUrl += "thsrc.svg";
            break;
          default:
            imgUrl += "warn.svg";
            break;
        }
        break;
      default:
        imgUrl += "walk.svg";
        break;
    }

    return imgUrl;
  }


  getTypeClass(type: string, mode:string){
    var classes = "sort ";
    switch(type){
      case "pedestrian":
      case "drive":
      case "cycle":
      case "waiting":
      default:
        classes += "d-none";
        break;
      case "pedestrian-station":
        classes += "walk";
        break;
      case "transit":
        switch(mode){
          case "TRA":
            classes += "train";
            break;
          case "HighwayBus":
            classes += "bus_02";
            break;
          case "Bus":
            classes += "bus_01";
            break;
          case "MRT":
            classes += "mrt";
            break;
          case "HSR":
            classes += "thsrc";
            break;
          default:
            classes += "d-none";
            break;
        }
        break;
    }

    return classes;
  }


  getBoxClass(type: string, mode:string){
    var classes = "tool ";
    switch(type){
      case "pedestrian":
      case "drive":
      case "cycle":
      case "pedestrian-station":
      case "waiting":
        break;
      case "transit":
        switch(mode){
          case "TRA":
            classes += "tl_04";
            break;
          case "HighwayBus":
          case "Bus":
            classes += "tl_01";
            break;
          case "MRT":
            classes += "tl_03";
            break;
          default:
            classes += "tl_02";
            break;
        }
        break;
    }

    return classes;
  }

  getdepartureName(type: string, place:string){
    switch(type){
      case "pedestrian":
        return "步行";
      case "drive":
        return "自行開車";
      case "cycle":
        return "自行車";
      case "waiting":
        return "等待";
      case "pedestrian-station":
      default:
        return "";
      case "transit":
        return place;
    }
  }


  back(){
    if(this.state == 3){
      this.callBack.emit(
        {
          state:1,
          num:0,
        }
      );
    }else{
      this.state = 3;
      this.callBack.emit(
        {
          state:3,
          num:0,
        }
      );

    }
  }

  onRadioChange(num:number){
    this.callBack.emit(
      {
        state:3,
        num:num,
      }
    );
    this.state = 3;
  }

  showDetail(num:number){
    this.detail = this.detailArray[num];
    this.callBack.emit(
      {
        state:4,
        num:num,
      }
    );
    this.state = 4;
  }
}
